import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { tabPropTypes, tabDefaultProps } from './Tabs.types.js';
import styles from './Tabs.module.scss.js';

var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onTabClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled;
            if (onClick && !disabled) {
                onClick(e);
            }
        };
        return _this;
    }
    Tab.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
    };
    Tab.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, isActive = _a.isActive, disabled = _a.disabled, testId = _a.testId, tabIndex = _a.tabIndex;
        // Tabindex should be -1 everywhere, except for the active tab. For more info, please visit https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html
        var Tabindex = tabIndex === -1 && isActive ? 0 : tabIndex;
        return (React__default.createElement("div", { className: styles.Tab + " " + (isActive ? styles.Tab___selected : '') + " " + (disabled ? styles.Tab___disabled : '') + " " + (className || ''), onClick: this.onTabClick, "data-testid": this.props['data-testid'] || testId, tabIndex: Tabindex },
            React__default.createElement("div", { className: styles["Tab_label" + (isActive ? '___selected' : '')] }, children)));
    };
    Tab.propTypes = tabPropTypes;
    Tab.defaultProps = __assign({}, tabDefaultProps);
    Tab.displayName = 'Tabs.Tab';
    return Tab;
}(React__default.Component));

export { Tab, Tab as default };
